import { ApolloClient, NormalizedCacheObject } from 'apollo-boost'

import { DayOfWeek } from '../../../../generated/graphql'
import { stores as STORES_QUERY } from '../../../../graphql/Query/Content/Stores.graphql'
import { MOCK_DATA } from '../../../data/StoresMocks'
import { ClientBehaviours } from '../../../utils'
import { ResolverProvider } from '../../types'

export const processesLowerCase = (param: string) => {
  return param.replace(/\s+/g, '-').toLowerCase()
}

const combineData = (data) => {
  return data.stores.reduce((stores, store) => {
    const { addressLine5, addressLine4 } = store.address
    const formattedValue = processesLowerCase(addressLine5)
    const formattedValue2 = processesLowerCase(addressLine4)

    if (addressLine5 && addressLine4) {
      if (!stores[formattedValue]) {
        stores[formattedValue] = { [formattedValue2]: [store] }
      } else {
        if (!stores[formattedValue][formattedValue2]) {
          stores[formattedValue] = {
            ...stores[formattedValue],
            [formattedValue2]: [store],
          }
        } else {
          stores[formattedValue][formattedValue2].push(store)
        }
      }
    }

    return stores
  }, {})
}

export enum StoresIconType {
  YES = 'YES',
  NO = 'NO',
}

export interface StoresData {
  stores: {
    id: number
    displayName: string
    urlTag: string
    phoneNumber: string
    email?: string
    relativeDistance: number
    openingTimes: {
      day: DayOfWeek
      openingTime: string
      closingTime: string
    }[]
    address: {
      country: string
      addresseeName: string
      addressLine1: string
      addressLine2: string
      addressLine3: string
      addressLine4: string
      addressLine5: string
      postalCode: string
    }
    storeFacility: {
      icon: StoresIconType
      title: string
    }[]
  }
}

export const Stores: ResolverProvider = (
  client: ApolloClient<NormalizedCacheObject>,
  {
    behaviours,
  }: {
    behaviours: ClientBehaviours
  },
) => async (_, args: { region: string; city: string }) => {
  const { region, city } = args

  if (behaviours.override) {
    const groupedData = combineData(MOCK_DATA)

    if (region) {
      if (city) {
        if (groupedData[region] && groupedData[region][city]) {
          return groupedData[region][city]
        }
        return null
      }
      if (groupedData[region]) {
        return groupedData[region]
      }
      return null
    }
    return groupedData
  }

  try {
    const { data } = await client.query({
      query: STORES_QUERY,
    })

    const groupedData = combineData(data)

    if (region) {
      if (city) {
        if (groupedData[region] && groupedData[region][city]) {
          return groupedData[region][city]
        }
        return null
      }
      if (groupedData[region]) {
        return groupedData[region]
      }
      return null
    }
    return groupedData
  } catch (error) {
    console.error('query failed:', error)
    throw new Error('Failed to fetch stores data')
  }
}
